export default {
  MOBILE: 'MOBILE',
  LAND_LINE: 'HOME'
}
